// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientBlock_root__XVP64","header":"PatientBlock_header__3FNnm","label":"PatientBlock_label__1ogDT","option":"PatientBlock_option__2CntY"};